<script>
export default {
  props: ["initLang"],
  data() {
    return {
      lang: this.initLang,
      holdApplyMainFilter: false,
      enableCompare: this.$parent.enableCompare,
      enableCountries: this.$parent.enableCountries,
      enableBrands: this.$parent.enableBrands,
      enableSites: this.$parent.enableSites,
      enableRange: this.$parent.enableRange,
      mainBrand: this.$parent.mainBrand,
      mainBrandEnableHighlight: false,
      mainBrandLabel: "",
      mainCountry: this.$parent.mainCountry,
      mainCountryEnableHighlight: false,
      mainCountryLabel: "",
      mainSite: this.$parent.mainSite,
      mainSiteEnableHighlight: false,
      mainSiteLabel: "",
      mainRangeEnableHighlight: true,
      mainRangeStart: this.$parent.mainRangeStart,
      mainRangeStartLabel: "",
      mainRangeEnd: this.$parent.mainRangeEnd,
      mainRangeEndLabel: "",
      mainRangeDeltaDays: 0,
      compareBrand: this.$parent.compareBrand,
      compareBrandEnableHighlight: false,
      compareBrandLabel: "",
      compareCountry: this.$parent.compareCountry,
      compareCountryEnableHighlight: false,
      compareCountryLabel: "",
      compareSite: this.$parent.compareSite,
      compareSiteEnableHighlight: false,
      compareSiteLabel: "",
      compareRangeEnableHighlight: false,
      compareRangeStart: this.$parent.compareRangeStart,
      compareRangeStartLabel: "",
      compareRangeEnd: this.$parent.compareRangeEnd,
      compareRangeEndLabel: "",
      compareRangeDeltaDays: 0
    };
  },
  mounted: function() {
    let dashboardMainFilter = this;

    dashboardMainFilter.lang = $.extend(
      {},
      dashboardMainFilter.$parent.lang,
      dashboardMainFilter.lang
    );

    dashboardMainFilter.initDaterangepicker();
    dashboardMainFilter.initSelect2();

    /* dashboardMainFilter.$nextTick(function () {
                $(window).on("scroll", function(){
                    $(dashboardMainFilter.$el).css({
                        "transform": "translateY(" + $(this).scrollTop() + "px)"
                    });
                });
            }); */

    Event.$on("dashboardMounted", function() {
      if (!dashboardMainFilter.holdApplyMainFilter) {
        dashboardMainFilter.applyMainFilter();
      }
    });
  },
  methods: {
    allButRangeEmpty: function() {
      let dashboardMainFilter = this;

      return (
        !dashboardMainFilter.mainBrand &&
        !dashboardMainFilter.compareBrand &&
        !dashboardMainFilter.mainCountry &&
        !dashboardMainFilter.compareCountry &&
        !dashboardMainFilter.mainSite &&
        !dashboardMainFilter.compareSite
      );
    },
    equalDaterangepickerToMain: function() {
      let dashboardMainFilter = this;

      dashboardMainFilter.compareRangeStart = $(
        ".dashboard__main-filter-range--main"
      )
        .data("daterangepicker")
        .startDate.format("YYYY-MM-DD");
      dashboardMainFilter.compareRangeEnd = $(
        ".dashboard__main-filter-range--main"
      )
        .data("daterangepicker")
        .endDate.format("YYYY-MM-DD");
      dashboardMainFilter.initDaterangepicker();
    },
    highlightFilter: function(element) {
      let dashboardMainFilter = this;

      $(".dashboard__main-filter-type").removeClass("active");
      element.closest(".dashboard__main-filter-type").addClass("active");
    },

    initDaterangepicker: function() {
      let dashboardMainFilter = this;

      moment.locale($("html").attr("lang"));

      dashboardMainFilter.mainRangeDeltaDays =
        moment(dashboardMainFilter.mainRangeEnd).diff(
          moment(dashboardMainFilter.mainRangeStart),
          "days"
        ) + 1;

      var ranges = {};
      ranges[dashboardMainFilter.lang["Last 7 days"]] = [
        moment().subtract(6, "days"),
        moment()
      ];
      ranges[dashboardMainFilter.lang["Last 30 days"]] = [
        moment().subtract(29, "days"),
        moment()
      ];
      ranges[dashboardMainFilter.lang["Last week"]] = [
        moment()
          .subtract(1, "week")
          .startOf("week"),
        moment()
          .subtract(1, "week")
          .endOf("week")
      ];
      ranges[dashboardMainFilter.lang["Last month"]] = [
        moment()
          .subtract(1, "month")
          .startOf("month"),
        moment()
          .subtract(1, "month")
          .endOf("month")
      ];
      ranges[dashboardMainFilter.lang["Last year"]] = [
        moment()
          .subtract(1, "year")
          .startOf("year"),
        moment()
          .subtract(1, "year")
          .endOf("year")
      ];

      var options = {
        opens: "left",
        autoUpdateInput: true,
        alwaysShowCalendars: true,
        locale: $.extend(true, {}, daterangepickerLocale, {
          format: "DD/MM/YYYY"
        })
      };

      function setRange(time, number) {
        let mainCalendar = $(".dashboard__main-filter-range--main");
        let compareCalendar = $(".dashboard__main-filter-range--compare")
        dashboardMainFilter.mainRangeStart = moment().subtract(number, time).format("YYYY-MM-DD");
        dashboardMainFilter.mainRangeEnd = moment().format("YYYY-MM-DD");
        dashboardMainFilter.compareRangeStart = moment().subtract(number + number, time).format("YYYY-MM-DD");
        dashboardMainFilter.compareRangeEnd = moment().subtract(number, time).format("YYYY-MM-DD");

        mainCalendar.data("daterangepicker").setStartDate(moment().subtract(number, time));
        mainCalendar.data("daterangepicker").setEndDate(moment());
        compareCalendar.data("daterangepicker").setStartDate(moment().subtract(number + number, time));
        compareCalendar.data("daterangepicker").setEndDate(moment().subtract(number, time));
      }

      $(".today-range").on("click", function() {
        setRange("days", 1);
        dashboardMainFilter.applyMainFilter();
      });

      $(".this-week-range").on("click", function() {
        setRange("days", 7);
        dashboardMainFilter.applyMainFilter();
      });

      $(".this-month-range").on("click", function() {
        setRange("month", 1);
        dashboardMainFilter.applyMainFilter();
      });

      $(".this-quarter-range").on("click", function() {
        setRange("month", 4);
        dashboardMainFilter.applyMainFilter();
      });

      $(".date-filters-tabs li").on("click", function() {
        $(".date-filters-tabs li").removeClass("active");
        $(this).addClass("active");
      })

      $(".dashboard__main-filter-range--main").daterangepicker(
        $.extend(true, {}, options, {
          startDate: moment(dashboardMainFilter.mainRangeStart).format(
            "DD/MM/YYYY"
          ),
          endDate: moment(dashboardMainFilter.mainRangeEnd).format("DD/MM/YYYY")
        }),

        function(start, end, label) {
          dashboardMainFilter.mainRangeStart = start.format("YYYY-MM-DD");
          dashboardMainFilter.mainRangeEnd = end.format("YYYY-MM-DD");
          dashboardMainFilter.mainRangeStartLabel = start.format("DD/MM/YYYY");
          dashboardMainFilter.mainRangeEndLabel = end.format("DD/MM/YYYY");
          dashboardMainFilter.mainRangeDeltaDays =
            moment(dashboardMainFilter.mainRangeEnd).diff(
              moment(dashboardMainFilter.mainRangeStart),
              "days"
            ) + 1;
          if (dashboardMainFilter.mainRangeEnableHighlight) {
            if (dashboardMainFilter.allButRangeEmpty()) {
              dashboardMainFilter.compareRangeStart = moment(
                dashboardMainFilter.mainRangeStart
              )
                .subtract(dashboardMainFilter.mainRangeDeltaDays, "days")
                .format("YYYY-MM-DD");
              dashboardMainFilter.compareRangeEnd = moment(
                dashboardMainFilter.mainRangeStart
              )
                .subtract(1, "days")
                .format("YYYY-MM-DD");
              dashboardMainFilter.compareRangeStartLabel = moment(
                dashboardMainFilter.compareRangeStart
              ).format("DD/MM/YYYY");
              dashboardMainFilter.compareRangeEndLabel = moment(
                dashboardMainFilter.compareRangeEnd
              ).format("DD/MM/YYYY");
              dashboardMainFilter.compareRangeDeltaDays =
                moment(dashboardMainFilter.compareRangeEnd).diff(
                  moment(dashboardMainFilter.compareRangeStart),
                  "days"
                ) + 1;
              $(".dashboard__main-filter-range--compare")
                .data("daterangepicker")
                .setStartDate(
                  moment(dashboardMainFilter.compareRangeStart).format(
                    "DD/MM/YYYY"
                  )
                );
              $(".dashboard__main-filter-range--compare")
                .data("daterangepicker")
                .setEndDate(
                  moment(dashboardMainFilter.compareRangeEnd).format(
                    "DD/MM/YYYY"
                  )
                );
            } else {
              dashboardMainFilter.holdApplyMainFilter = true;
              dashboardMainFilter.compareRangeEnableHighlight = false;
              dashboardMainFilter.equalDaterangepickerToMain();
              dashboardMainFilter.holdApplyMainFilter = false;
            }
          }
          dashboardMainFilter.mainRangeEnableHighlight = true;
          if (!dashboardMainFilter.holdApplyMainFilter) {
            dashboardMainFilter.applyMainFilter();
          }
        }
      );
      dashboardMainFilter.mainRangeStartLabel = moment(
        dashboardMainFilter.mainRangeStart
      ).format("DD/MM/YYYY");
      dashboardMainFilter.mainRangeEndLabel = moment(
        dashboardMainFilter.mainRangeEnd
      ).format("DD/MM/YYYY");

      dashboardMainFilter.compareRangeDeltaDays =
        moment(dashboardMainFilter.compareRangeEnd).diff(
          moment(dashboardMainFilter.compareRangeStart),
          "days"
        ) + 1;

      options.ranges = [];
      options.ranges[dashboardMainFilter.lang["Main"]] = [
        moment(dashboardMainFilter.mainRangeStart),
        moment(dashboardMainFilter.mainRangeEnd)
      ];
      options.ranges[dashboardMainFilter.lang["Main previous"]] = [
        moment(dashboardMainFilter.mainRangeStart).subtract(
          dashboardMainFilter.mainRangeDeltaDays,
          "day"
        ),
        moment(dashboardMainFilter.mainRangeStart).subtract(1, "day")
      ];
      if (dashboardMainFilter.mainRangeDeltaDays <= 7) {
        options.ranges[dashboardMainFilter.lang["Main -1 week"]] = [
          moment(dashboardMainFilter.mainRangeStart).subtract(1, "week"),
          moment(dashboardMainFilter.mainRangeEnd).subtract(1, "week")
        ];
      }
      if (dashboardMainFilter.mainRangeDeltaDays <= 30) {
        options.ranges[dashboardMainFilter.lang["Main -1 month"]] = [
          moment(dashboardMainFilter.mainRangeStart).subtract(1, "month"),
          moment(dashboardMainFilter.mainRangeEnd).subtract(1, "month")
        ];
      }
      if (dashboardMainFilter.mainRangeDeltaDays <= 365) {
        options.ranges[dashboardMainFilter.lang["Main -1 year"]] = [
          moment(dashboardMainFilter.mainRangeStart).subtract(1, "year"),
          moment(dashboardMainFilter.mainRangeEnd).subtract(1, "year")
        ];
      }

      $(".dashboard__main-filter-range--compare").daterangepicker(
        $.extend(true, {}, options, {
            startDate: moment(dashboardMainFilter.compareRangeStart).format(
              "DD/MM/YYYY"
            ),
            endDate: moment(dashboardMainFilter.compareRangeEnd).format(
              "DD/MM/YYYY"
            )
          }
        ),
        function(start, end, label) {
          dashboardMainFilter.compareRangeStart = start.format("YYYY-MM-DD");
          dashboardMainFilter.compareRangeEnd = end.format("YYYY-MM-DD");
          dashboardMainFilter.compareRangeStartLabel = start.format(
            "DD/MM/YYYY"
          );
          dashboardMainFilter.compareRangeEndLabel = end.format("DD/MM/YYYY");
          dashboardMainFilter.compareRangeDeltaDays =
            moment(dashboardMainFilter.compareRangeEnd).diff(
              moment(dashboardMainFilter.compareRangeStart),
              "days"
            ) + 1;

          if (dashboardMainFilter.compareRangeEnableHighlight) {
            dashboardMainFilter.holdApplyMainFilter = true;
            dashboardMainFilter.mainBrandEnableHighlight = false;
            $("[name='main_brand']", dashboardMainFilter.$el)
              .val("")
              .trigger("change");
            dashboardMainFilter.compareBrandEnableHighlight = false;
            $("[name='compare_brand']", dashboardMainFilter.$el)
              .val("")
              .trigger("change");
            dashboardMainFilter.mainCountryEnableHighlight = false;
            $("[name='main_country']", dashboardMainFilter.$el)
              .val("")
              .trigger("change");
            dashboardMainFilter.compareCounrtyEnableHighlight = false;
            $("[name='compare_country']", dashboardMainFilter.$el)
              .val("")
              .trigger("change");
            dashboardMainFilter.mainSiteEnableHighlight = true;
            $("[name='main_site']", dashboardMainFilter.$el)
              .val("")
              .trigger("change");
            dashboardMainFilter.compareSiteEnableHighlight = false;
            $("[name='compare_site']", dashboardMainFilter.$el)
              .val("")
              .trigger("change");
            dashboardMainFilter.highlightFilter(
              $(".dashboard__main-filter-range--compare")
            );
            dashboardMainFilter.holdApplyMainFilter = false;
          }
          dashboardMainFilter.compareRangeEnableHighlight = true;
          if (!dashboardMainFilter.holdApplyMainFilter) {
            dashboardMainFilter.applyMainFilter();
          }
        }
      );
      dashboardMainFilter.compareRangeStartLabel = moment(
        dashboardMainFilter.compareRangeStart
      ).format("DD/MM/YYYY");
      dashboardMainFilter.compareRangeEndLabel = moment(
        dashboardMainFilter.compareRangeEnd
      ).format("DD/MM/YYYY");
    },
    initSelect2: function() {
      let dashboardMainFilter = this;

      //main
      $(dashboardMainFilter.$el).on(
        "change",
        "[name='main_brand']",
        function() {
          dashboardMainFilter.mainBrand = $(this).val();
          dashboardMainFilter.mainBrandLabel = $("option:selected", this).text()
            ? $("option:selected", this).text()
            : $(this).data("placeholder");
          if (dashboardMainFilter.mainBrandEnableHighlight) {
            dashboardMainFilter.compareRangeEnableHighlight = true;
            dashboardMainFilter.equalDaterangepickerToMain();
            dashboardMainFilter.highlightFilter($(this));
          }
          dashboardMainFilter.mainBrandEnableHighlight = true;
          if (!dashboardMainFilter.holdApplyMainFilter) {
            dashboardMainFilter.applyMainFilter();
          }
        }
      );
      $("[name='main_brand']", dashboardMainFilter.$el)
        .val(dashboardMainFilter.mainBrand)
        .trigger("change");

      $(dashboardMainFilter.$el).on(
        "change",
        "[name='main_country']",
        function() {
          dashboardMainFilter.mainCountry = $(this).val();
          dashboardMainFilter.mainCountryLabel = $(
            "option:selected",
            this
          ).text()
            ? $("option:selected", this).text()
            : $(this).data("placeholder");
          if (dashboardMainFilter.mainCountryEnableHighlight) {
            dashboardMainFilter.compareRangeEnableHighlight = true;
            dashboardMainFilter.equalDaterangepickerToMain();
            dashboardMainFilter.highlightFilter($(this));
          }
          dashboardMainFilter.mainCountryEnableHighlight = true;
          if (!dashboardMainFilter.holdApplyMainFilter) {
            dashboardMainFilter.applyMainFilter();
          }
        }
      );
      $("[name='main_country']", dashboardMainFilter.$el)
        .val(dashboardMainFilter.mainCountry)
        .trigger("change");

      $(dashboardMainFilter.$el).on("change", "[name='main_site']", function() {
        dashboardMainFilter.mainSite = $(this).val();
        dashboardMainFilter.mainSiteLabel = $("option:selected", this).text()
          ? $("option:selected", this).text()
          : $(this).data("placeholder");
        if (dashboardMainFilter.mainSiteEnableHighlight) {
          dashboardMainFilter.compareRangeEnableHighlight = true;
          dashboardMainFilter.equalDaterangepickerToMain();
          dashboardMainFilter.highlightFilter($(this));
        }
        dashboardMainFilter.mainSiteEnableHighlight = true;
        if (!dashboardMainFilter.holdApplyMainFilter) {
          dashboardMainFilter.applyMainFilter();
        }
      });
      $("[name='main_site']", dashboardMainFilter.$el)
        .val(dashboardMainFilter.mainSite)
        .trigger("change");

      //compare
      $(dashboardMainFilter.$el).on(
        "change",
        "[name='compare_brand']",
        function() {
          dashboardMainFilter.compareBrand = $(this).val();
          dashboardMainFilter.compareBrandLabel = $(
            "option:selected",
            this
          ).text()
            ? $("option:selected", this).text()
            : $(this).data("placeholder");
          if (dashboardMainFilter.compareBrandEnableHighlight) {
            dashboardMainFilter.compareRangeEnableHighlight = true;
            dashboardMainFilter.equalDaterangepickerToMain();
            dashboardMainFilter.highlightFilter($(this));
          }
          dashboardMainFilter.compareBrandEnableHighlight = true;
          if (!dashboardMainFilter.holdApplyMainFilter) {
            dashboardMainFilter.applyMainFilter();
          }
        }
      );
      $("[name='compare_brand']", dashboardMainFilter.$el)
        .val(dashboardMainFilter.compareBrand)
        .trigger("change");

      $(dashboardMainFilter.$el).on(
        "change",
        "[name='compare_country']",
        function() {
          dashboardMainFilter.compareCountry = $(this).val();
          dashboardMainFilter.compareCountryLabel = $(
            "option:selected",
            this
          ).text()
            ? $("option:selected", this).text()
            : $(this).data("placeholder");
          if (dashboardMainFilter.compareCountryEnableHighlight) {
            dashboardMainFilter.compareRangeEnableHighlight = true;
            dashboardMainFilter.equalDaterangepickerToMain();
            dashboardMainFilter.highlightFilter($(this));
          }
          dashboardMainFilter.compareCountryEnableHighlight = true;
          if (!dashboardMainFilter.holdApplyMainFilter) {
            dashboardMainFilter.applyMainFilter();
          }
        }
      );
      $("[name='compare_country']", dashboardMainFilter.$el)
        .val(dashboardMainFilter.compareCountry)
        .trigger("change");

      $(dashboardMainFilter.$el).on(
        "change",
        "[name='compare_site']",
        function() {
          dashboardMainFilter.compareSite = $(this).val();
          dashboardMainFilter.compareSiteLabel = $(
            "option:selected",
            this
          ).text()
            ? $("option:selected", this).text()
            : $(this).data("placeholder");
          if (dashboardMainFilter.compareSiteEnableHighlight) {
            dashboardMainFilter.compareRangeEnableHighlight = true;
            dashboardMainFilter.equalDaterangepickerToMain();
            dashboardMainFilter.highlightFilter($(this));
          }
          dashboardMainFilter.compareSiteEnableHighlight = true;
          if (!dashboardMainFilter.holdApplyMainFilter) {
            dashboardMainFilter.applyMainFilter();
          }
        }
      );
      $("[name='compare_site']", dashboardMainFilter.$el)
        .val(dashboardMainFilter.compareSite)
        .trigger("change");
    },
    applyMainFilter: function() {
      let dashboardMainFilter = this;
      $(".alert").alert("close");
      Event.$emit("mainFilterChanged", dashboardMainFilter);
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/js/components/admin/dashboards/dashboardMainFilter.vue